<div class="custom-snackbar" data-testid="snackbar">
  <div
    class="custom-snackbar__icon"
    [ngClass]="{
      'custom-snackbar__icon__success': snackType === 'Success',
      'custom-snackbar__icon__error': snackType === 'Error',
      'custom-snackbar__icon__warning': snackType === 'Warning',
      'custom-snackbar__icon__info': snackType === 'Info'
    }"
  >
    <span class="custom-snackbar__icon__icon material-icons-outlined">
      {{ icon }}
    </span>
  </div>
  <div
    class="custom-snackbar__message"
    [ngClass]="{
      'custom-snackbar__message__success': snackType === 'Success',
      'custom-snackbar__message__error': snackType === 'Error',
      'custom-snackbar__message__warning': snackType === 'Warning',
      'custom-snackbar__message__info': snackType === 'Info'
    }"
  >
    <span class="custom-snackbar__message__text" data-testid="snackbar-message">{{
      message | translate
    }}</span>
  </div>
</div>
